export enum SearchQueryType {
    Simple,
    Semantic,
}
